<template>
  <span :class="isMobileAndNL || hideContact ? '' : 'nav-contact-mobile'">
    <div v-if="isMobileAndNL || hideContact"></div>
    <router-link v-else :to="dynamicEntity.to">
      {{ dynamicEntity.text }}
    </router-link>
  </span>
</template>
<script>
import region from '@/../region.json';
import matchEntities, {
  NETHERLANDS,
  isTechPagesOnlyEntity,
} from '../../shared/entityHelpers';

export default {
  data() {
    return {
      defaultLang: region.defaultLang,
      dynamicEntity: {
        text: this.text(),
        to: this.to(),
      },
    };
  },
  methods: {
    text() {
      if (matchEntities(['NETHERLANDS']))
        return this.$i18n.t('navigation.google_form_cta');
      return this.$i18n.t('navigation.contact');
    },
    to() {
      if (matchEntities(['NETHERLANDS'])) {
        return NETHERLANDS.externalFormCTALink;
      }
      return this.$i18n.locale === this.defaultLang
        ? `/${this.defaultLang}/contact`
        : '/en/contact';
    },
    matchEntities,
  },
  computed: {
    isMobileAndNL() {
      return matchEntities(['NETHERLANDS']) && window.innerWidth < 768;
    },
    hideContact() {
      // The contact page is not reachable on tech-pages-only sites (Denmark),
      // so the mobile contact CTA would only lead to the 404 page.
      return isTechPagesOnlyEntity();
    },
  },
};
</script>
